import { createSlice } from '@reduxjs/toolkit';

interface IInitialState {
  dismissIds: Array<string>;
}

const initialState: IInitialState = {
  dismissIds: [],
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setDismissId: (state, action) => {
      const existId = state.dismissIds.find((id) => id === action.payload);
      if (!existId) {
        state.dismissIds.push(action.payload);
      }
    },
  },
});
